import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-qterms',
  templateUrl: './qterms.component.html',
  styleUrls: ['./qterms.component.scss']
})
export class QTermsComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<QTermsComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {

  }

  close() {
    this.dialogRef.close(true);
  }
}
